import { h } from "@stencil/core";

export const RenderContentStep = (step, baseClass) => {
    return (
        <div class={`${baseClass}__content`}>
            <div class={`${baseClass}__text-wrapper`}>
                {step?.headline && (
                    <div
                        class={`${baseClass}__headline ux-text-headline ux-text-headline--giant ux-u-mb-xxxs`}
                    >
                        {step.headline}
                    </div>
                )}
                {step?.subline && (
                    <div
                        class={`${baseClass}__subline ux-text-headline ux-text-headline--small ux-u-mb-xxxs`}
                    >
                        {step.subline}
                    </div>
                )}
                {step?.text && (
                    <div
                        class={`${baseClass}__copy ux-text-normal ux-u-mb-xs`}
                        innerHTML={step.text}
                    ></div>
                )}
                {step?.hint && (
                    <div
                        class={`${baseClass}__hint ux-text-normal ux-text-normal--bold ux-u-mb-xs`}
                    >
                        <ux-icon name="square-info" weight="bold"></ux-icon>
                        {step.hint}
                    </div>
                )}
                {step?.machines && (
                    <div class={`${baseClass}__machines-wrapper`}>
                        <ux-slider class="ux-u-mb-xxxs" no-arrows>
                            {step.machines.map((item) => {
                                return (
                                    <ux-slider-slide>
                                        <div class={`${baseClass}__machines`}>
                                            <div
                                                class={`${baseClass}__machines-media`}
                                            >
                                                <uxc-auth-image
                                                    src={item.imageSrc}
                                                    scope="mytrumpf"
                                                >
                                                    <ux-image
                                                        alt={item.name}
                                                    ></ux-image>
                                                </uxc-auth-image>
                                            </div>
                                            <div
                                                class={`${baseClass}__machines-text`}
                                            >
                                                <div
                                                    class={`${baseClass}__name ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase`}
                                                >
                                                    {item.name}
                                                </div>
                                                <div
                                                    class={`${baseClass}__number ux-text-tiny`}
                                                >
                                                    {item.number}
                                                </div>
                                            </div>
                                        </div>
                                    </ux-slider-slide>
                                );
                            })}
                            <ux-slider-pagination
                                slot="pagination"
                                bottom-pagination
                            ></ux-slider-pagination>
                        </ux-slider>
                    </div>
                )}
                {step?.buttons && (
                    <div class={`${baseClass}__button-wrapper`}>
                        {step.buttons.map((button) => {
                            return (
                                <ux-button
                                    variant={button.variant}
                                    href={button.url}
                                >
                                    {button.label}
                                </ux-button>
                            );
                        })}
                    </div>
                )}
            </div>
            <div class={`${baseClass}__media-wrapper`}>
                {step?.mediaElements && (
                    <ux-slider no-arrows>
                        {step.mediaElements.map((item) => {
                            return (
                                <ux-slider-slide>
                                    <div class={`${baseClass}__media`}>
                                        {item.type === "image" ? (
                                            <ux-image
                                                src={item.url}
                                                alt={item.alt}
                                            ></ux-image>
                                        ) : null}
                                        {item.type === "video" ? (
                                            <ux-video>
                                                <video
                                                    autoplay
                                                    loop
                                                    muted
                                                    playsinline
                                                >
                                                    <source
                                                        src={item.url}
                                                        type="video/mp4"
                                                    />
                                                </video>
                                            </ux-video>
                                        ) : null}
                                    </div>
                                    <div
                                        class={`${baseClass}__media_caption ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase`}
                                        innerHTML={item.caption}
                                    ></div>
                                </ux-slider-slide>
                            );
                        })}
                        <ux-slider-pagination
                            slot="pagination"
                            bottom-pagination
                        ></ux-slider-pagination>
                    </ux-slider>
                )}
            </div>
        </div>
    );
};
